import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {Project, ProjectPlugin} from '../../../../core/models';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {ProjectSidebarService} from '../../../../projectsidebar.service';
import {ProjectService} from "../../../../core/services";
import {MobileEventTypeProjectRelService} from "../../../../core/services/mobileEventTypeProjectRel.service";


@Component({
  selector: 'app-project-plugins',
  templateUrl: './project-plugins.page.html',
  styleUrls: ['./project-plugins.page.scss']
})
export class ProjectPluginsPage implements OnInit {
  @Input() project: Project;

  loading = false;
  id: string;
  plugins: any;
  selectedPlugins: any;


  constructor(
    private route: ActivatedRoute,
    private projectSidebarService: ProjectSidebarService,
    private projectService: ProjectService,
    private mobileEventTypeProjectRelService: MobileEventTypeProjectRelService,
    private breadcrumbService: BreadcrumbService
  ) {
  }

  ngOnInit() {
    this.loading = true;

    this.route.parent.params.subscribe((params) => {
      this.id = params.id;
    });

    this.route.parent.data.subscribe(
      (data) => {
        if (data.project) {
          this.project = data.project;
          this.breadcrumbService.setItems([
            {label: 'projects', routerLink: ['/project', 'list']},
            {label: this.project.name},
            {label: 'plugins',},
          ]);

          this.loadPlugins();
          this.projectSidebarService.setProject(this.project);
        }
        this.loading = false;
      }
    );
  }

  loadPlugins() {
    this.projectService.getPluginSettings(this.id).subscribe(
        (data) => {
          this.plugins = data.plugins;
        });
  }

  updatePluginSettings() {
      this.loading = true;
      this.selectedPlugins = this.plugins.filter(p => p.value === true);
      this.mobileEventTypeProjectRelService.updatePluginValidations(this.id, this.selectedPlugins).subscribe(
          (data) => {
            this.loading = false;
          },
          (error) => {
            this.loading = false;
          });
  }

}
